import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, ShowVerticalScrollbar } from '../../global/commonStyle';

interface OptionProps {
  selected?: boolean;
  focused?: boolean;
  isSelected?: boolean;
  isFocused?: boolean;
}

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

const SelectInput = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  width: 100%;
  cursor: text;
  flex-wrap: wrap;
  cursor: text;
  *::selection {
    background: transparent;
    color: inherit;
  }
`;

const Tag = styled.div`
  ${AlignCenter}
  background: var(--neutral-secondary);
  border-radius: var(--border-radius-full);
  padding: var(--space-4) var(--space-6) var(--space-4) var(--space-4);
  border: 0.5px solid var(--border-primary);
  .close-icon-tag:hover {
    background: var(--background-muted);
    ${mobile_xl(css`
      background: unset;
    `)}
  }
`;

const TagAvatar = styled.div`
  padding-right: var(--space-6);
  ${FlexCenter}
  gap: var(--space-8);
  border-radius: var(--border-radius-full);
  overflow: hidden;
  .teamcamp-icon {
    rect {
      fill: var(--background-tertiary);
      stroke: var(--border-primary);
    }
    path {
      fill: var(--text-primary);
    }
  }
`;

const TagName = styled.span`
  white-space: nowrap;
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

const Dropdown = styled.div<{ isOpen: boolean; tagsSelected?: boolean }>`
  position: absolute;
  top: calc(100% + 16px);
  top: calc(100% + 7px);
  left: 0;
  width: 100%;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
  box-shadow: var(--shadow-dropdown);
  z-index: var(--z-index-modal);
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  ${mobile_xl(css<{ tagsSelected?: boolean }>`
    top: calc(100% + 8px);
  `)}
`;

const ItemsList = styled.div`
  max-height: 180px;
  ${ShowVerticalScrollbar}
  margin-right: var(--space-4);
  padding: var(--space-4) 0;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: var(--space-8) var(--space-12);
  border: none;
  border-bottom: 0.5px solid var(--border-primary);
  background: transparent;
  color: var(--text-primary);
  &:focus {
    outline: none;
  }
`;

const Option = styled.div<OptionProps>`
  padding: var(--space-4) var(--space-6);
  margin-inline: var(--space-4);
  border-radius: var(--border-radius-4);
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
  background: ${({ selected, focused, isSelected, isFocused }) =>
    focused || isFocused || selected || isSelected ? 'var(--neutral-secondary)' : 'transparent'};
  &:hover {
    background: var(--neutral-secondary);
  }
`;

const OptionAvatar = styled.div`
  min-width: 28px;
  height: 28px;
  border-radius: var(--border-radius-full);
  overflow: hidden;
  .teamcamp-icon {
    rect {
      fill: var(--background-tertiary);
      stroke: var(--border-primary);
    }
    path {
      fill: var(--text-primary);
    }
  }
`;

const OptionName = styled.span`
  ${Typography.body_md}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-primary);
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  ${Typography.body_lg}
  :placeholder {
    color: var(--text-placeholder);
  }
  width: 100%;
  flex: 1;
  padding-block: var(--space-6);
`;
export {
  SelectContainer,
  SelectInput,
  Tag,
  TagAvatar,
  TagName,
  Dropdown,
  SearchInput,
  Option,
  OptionAvatar,
  OptionName,
  Input,
  ItemsList
};
